/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ring_CoreInputs */

const en_ring_core = /** @type {(inputs: Ring_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexxt`)
};

/**
* | output |
* | --- |
* | "Nexxt" |
*
* @param {Ring_CoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ring_core = /** @type {((inputs?: Ring_CoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ring_CoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ring_core(inputs)
});